import { Component } from '@angular/core'
import { NavParams, ViewController } from 'ionic-angular';
@Component({
    templateUrl: 'shipments.modal.html',
})
export class ShipmentsDetailPage {
    item: any;
    constructor(params: NavParams, private viewCtrl: ViewController) {
        this.item = params.data;
        console.log(JSON.stringify(this.item));
    }
    dismiss() {
        this.viewCtrl.dismiss();
    }
}


// WEBPACK FOOTER //
// ./src/pages/backoffice/shipments/shipments.modal.ts